module.exports = __webpack_public_path__ + "47d1583f334ab50ded1bc3e922f38e6f.ttf";